module.exports = __webpack_public_path__ + "static/media/add_box.d7ceed52.svg";